module.exports = __webpack_public_path__ + "static/img/title.cd9d62f.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/allopa/title.jpeg
// module id = 349
// module chunks = 1